@if (parentNode) {
  <div class="parent-node" oSticky (click)="update(parentNode.parent)">
    @if (parentNode._id === "root") {
      <h3>{{ "toc.title" | translate }}</h3>
    } @else {
      <div>
        <mat-icon class="on_background" svgIcon="subdirectory-arrow-left"></mat-icon>
        <h3>{{ parentNode.title }}</h3>
      </div>
    }
  </div>
}

@if (loading) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}

<div class="toc-container">
  @for (tocNode of toc; track tocNode._id) {
    <div>
      <!-- Before v2.7.34, standalone additional documents had their DMC equal to their parent's ID.
      This could create a compatibility problem with new versions.
      Hence, instead of using the DMC, we decided to utilize the ID because it remained unchanged and identical to the DMC since v2.7.34
      see more on: https://gitlab.altengroup.net/tma/airbus/orion/orion2/orion2/-/merge_requests/2860 -->
      @if (tocNode.dmc && tocNode.dmc !== "loap") {
        <o-orion-card
          role="button"
          title="toc card"
          oHistoric
          [historicData]="tocNode"
          [from]="HistorySource.TOC"
          [class.selected-node]="tocNode._id === dmcSelected"
          [data]="tocNode | orionCardFormatter: orionCardSource.TOC"
          [routerLink]="tocNode._id | getDUUrl: dmcSelected">
        </o-orion-card>
      } @else if (!tocNode.dmc) {
        <div
          mat-list-item
          role="button"
          class="folder"
          [class.not-applicable]="tocNode.notApplicable"
          [class.hide-not-applicable]="tocNode.notApplicable && !store.showNotApplicable"
          (click)="update(tocNode._id)">
          {{ tocNode.title }}
        </div>
      }
    </div>
  }
</div>
